<template>
    <div>
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <form @submit.prevent="update">
            <div class="px-8 py-4 flex flex-wrap" @change="dirtyForm()" @keydown="dirtyForm">
                <select-input id="pd_nat" 
                              v-model="form.nationality_id"
                              :error="form.errors?.nationality_id" 
                              class="pr-6" label="* Nationality (primary)" 
                              @update:modelValue="value = $event"
                >
                    <option v-for="country in nationality" :key="country.reference" :value="country.reference">{{ country.name }}</option>
                </select-input>
                <select-input id="pd_nat_dual" v-model="form.dual_nationality_id" :error="form.errors?.dual_nationality_id" class="pr-6" label="Other Nationality" @update:modelValue="value = $event">
                    <option v-for="country in nationality" :key="country.reference" :value="country.reference">{{ country.name }}</option>
                </select-input>
                <text-input v-if="!isScOrModule" v-model="form.passport_number" class="pr-6" label="Passport/EU identity card number" @update:modelValue="value = $event" />
                <div class="w-full" />
                <div v-if="!isScOrModule" class="md:inline-block mb-4">
                    <div class="">
                        <p>* Do you have the right to permanent residence in the UK/EU? </p>
                    </div>
                    <div class="text-left mx-4 mt-2">
                        <div class="md:inline-block">
                            <input id="remain-yes-option"
                                   v-model="form.right_to_remain"
                                   :value="1"
                                   type="radio"
                                   name="right_to_remain"
                                   @update:modelValue="value = $event"
                            />
                            <label for="remain-yes-option" class="ml-2"><strong>Yes</strong></label>
                        </div>
                        <div class="md:inline-block mx-4">
                            <input id="remain-no-option"
                                   v-model="form.right_to_remain"
                                   :value="0"
                                   type="radio"
                                   name="right_to_remain"
                                   @update:modelValue="value = $event"
                            />
                            <label for="remain-no-option" class="ml-2"><strong>No</strong></label>
                        </div>
                        <span v-if="form.errors?.right_to_remain" style="color: #a94442">This field is required</span>
                    </div>
                </div>
                <div class="w-full" />
                <div class="w-full" />
                <select-input id="pd_cob" v-model="form.country_of_birth_id" :error="form.errors?.country_of_birth_id" class="pr-6" label="* Country of Birth" @update:modelValue="value = $event">
                    <option v-for="country in countriesOfBirthList" :key="country.reference" :value="country.reference">{{ country.name }}</option>
                </select-input>
                <select-input id="pd_cod" v-model="form.country_of_domicile_id" :error="form.errors?.country_of_domicile_id" class="pr-6" label="* Country of Domicile" @update:modelValue="value = $event">
                    <option v-for="country in countriesOfDomicileList" :key="country.reference" :value="country.reference">{{ country.name }}</option>
                </select-input>
            </div>
            <div v-if="successMessage.length > 0" class="success-message m-8 w-auto">Nationality details updated</div>
            <div v-if="validationErrors !== undefined">
                <div v-if="Object.keys(validationErrors).length > 0">
                    <p class="server-error m-8">There were some validation issues, please check the fields above</p>
                </div>
            </div>
            <div class="lg:flex justify-end w-full pb-2 -mt-8">
                <div class="relative w-auto lg:w-1/3 mx-8">
                    <application-component-save-button :disabled="formDirty" class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                       type="submit"
                    >
                        Save Nationality Details
                        <div v-if="loading" class="lds-ring-container absolute top-10">
                            <div class="lds-ring">
                                <div /><div /><div /><div />
                            </div>
                        </div>
                    </application-component-save-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    components: {
        TextInput,
        SelectInput,
        ApplicationComponentSaveButton,
    },
    props: {
        reference: String,
        personalData: Object,
        applicationData: Object,
        genders: Array,
        titlesList: Object,
        countriesOfDomicileList: Object,
        countriesOfBirthList: Object,
        nationality: Array,
    },
    data() {
        return {
            form: ({
                application_id: this.reference,
                nationality_id: this.applicationData.data.nationality_id,
                dual_nationality_id: this.applicationData.data.dual_nationality_id,
                right_to_remain: this.applicationData.data.right_to_remain,
                passport_number: this.applicationData.data.passport_number,
                country_of_birth_id: this.applicationData.data.country_of_birth_id,
                country_of_domicile_id: this.applicationData.data.country_of_domicile_id,
                errors: {},
            }),
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
        }
    },
    computed: {
        validationErrors: {
            get: function() {
                return this.form.errors
            },
            set: function(newValue) {
                for (const key in newValue)
                {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },
        isScOrModule() {
            return ['S','U'].includes(this.applicationData.data?.programmeCode)
        },
    },
    methods: {
        update() {
            this.loading = true
            this.$store.dispatch('updateNationalityDetails', {
                personalData: this.form,
                reference: this.reference,
            })
                .then(() => {
                    this.loading = false
                    this.serverErrors = ''
                    this.form.errors = {}
                    this.successMessage = 'Nationality details saved'
                    window.location.search += '&section=nationalityShow'
                })
                .catch(error => {
                    this.loading = false
                    this.form.errors = error.response.data.errors
                    this.validationErrors = error.response.data.errors
                    this.successMessage = ''
                })
            this.formDirty = false
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
    },
}
</script>